
// ref: https://gitlab.com/web-apps-dietela/backend/-/merge_requests/252

export const reqUpdateContentMonthGroup = async(axios, { id }, { title, description, image }) => {
  return axios.put(`/v1/admin/content-month-group/${id}`, {
    title, // string!
    description, // string!
    image, // string!
  })
}